import React, { useState } from 'react';
import { Card, Table, Row, Col, Form, Button } from "react-bootstrap";
import { io } from 'socket.io-client';
const socket = io('http://192.168.1.109:3012');

const Index = () => {
    const [dataMessage, setDataMessage] = useState([
        {'message':'Test'},
        {'message':'Test 2'},
        {'message':'Test 3'},
        {'message':'Test 4'},
        {'message':'Test 5'},
        {'message':'Test 6'}
    ]);
    const [message, setMessage] = useState(null);

    // const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));

    const handleChange = (event) => {
        const {value} = event.target;
        setMessage(value);
    }

    const sendMessage = () => {
        let dataMessageTemp = {'message':message};
        
        setMessage('');
        setDataMessage(prevState => [...prevState, dataMessageTemp]);
        const emitData = {
            'id': 'admin',
            'message':message
        }
        socket.emit('message', emitData);
    }

    // useEffect(() => {
    //     socket.on(ACCESS_USER.username, (msg) => {
    //         console.log(msg);
    //         let dataMessageTemp = {'message':msg};
        
    //         setMessage('');
    //         setDataMessage(prevState => [...prevState, dataMessageTemp]);
    //     });
    // },[])

    return (
        <Card className="">
            <Card.Body className="p-0 h-100">
                <Table>
                    {
                        dataMessage.map((val, idx) => {
                            return (
                                <tr key={idx}>
                                    <td>{val.message}</td>
                                    <td>as</td>
                                    <td></td>
                                </tr>
                            )
                        })
                    }
                </Table>

                <Row>
                    <Col md="8">
                        <Form.Control
                            type="text"
                            value={message}
                            onChange={(event) => handleChange(event)}
                            name="vcname"
                            placeholder="Nama" 
                            required
                        />
                    </Col>
                    <Col md="4">
                        <Button variant="secondary" onClick={sendMessage}>
                            Send
                        </Button> 
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

Index.propTypes = {}

export default Index;